// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#LeftPanel {
    width: 30%;
    max-height: 85vh!important;
}

#RightPanel {
    width: 60%;
    background: #161717;
    max-height: 85vh!important;
}

@media(max-width: 850px) {
    #root {
        height: 100%;
    }

    #LeftPanel {
        width: 90%;
        height: 400px;
    }

    #RightPanel {
        width: 90%;
        height: 500px;
    }
}

@media(max-width: 600px) {
    #LeftPanel {
        width: 95%;
    }

    #RightPanel {
        width: 95%;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["#LeftPanel {\n    width: 30%;\n    max-height: 85vh!important;\n}\n\n#RightPanel {\n    width: 60%;\n    background: #161717;\n    max-height: 85vh!important;\n}\n\n@media(max-width: 850px) {\n    #root {\n        height: 100%;\n    }\n\n    #LeftPanel {\n        width: 90%;\n        height: 400px;\n    }\n\n    #RightPanel {\n        width: 90%;\n        height: 500px;\n    }\n}\n\n@media(max-width: 600px) {\n    #LeftPanel {\n        width: 95%;\n    }\n\n    #RightPanel {\n        width: 95%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
